import {useQuery} from "react-query";
import {system} from "../../../../API/TT_ELD/Team/system";

export const useSystem = (): any => {
    return useQuery([
            `system/`,],
        () => system.read(),
        { refetchOnWindowFocus: false})
}